import { Component, OnInit } from '@angular/core';
import { EventTypes } from '@caslink/common-client';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';

export interface ConnectionStatus {
    color?: string;
    text: ConnectionStatusState;
}

export const enum ConnectionStatusState {
    Initializing = 'INITIALIZING...',
    Active = 'ON',
    Inactive = 'OFF'
}

@Component({
    selector: 'cl-connection-status',
    templateUrl: './connection-status.component.html',
    styleUrls: [ './connection-status.component.scss' ]
})
export class ConnectionStatusComponent implements OnInit {
    static $name: string = 'clConnectionStatus';

    connectionStatus: ConnectionStatus;

    constructor(private commonBroadcastService: CommonBroadcastService) {
    }

    ngOnInit() {
        this.connectionStatus = ConnectionStatusComponent.getInitializingStatus();

        this.commonBroadcastService.on(EventTypes.ConnectedToServer).subscribe( () => {
            this.connectionStatus = ConnectionStatusComponent.getActiveStatus();
        });

        this.commonBroadcastService.on(EventTypes.DisconnectedFromServer).subscribe(() => {
            this.connectionStatus = ConnectionStatusComponent.getInactiveStatus();
        });

        this.commonBroadcastService.on(EventTypes.ReconnectedToServer).subscribe(() => {
            this.connectionStatus = ConnectionStatusComponent.getActiveStatus();
        });
    }

    private static getInitializingStatus(): ConnectionStatus {
        return {
            text: ConnectionStatusState.Initializing
        };
    }

    private static getActiveStatus(): ConnectionStatus {
        return {
            color: 'green-ok',
            text: ConnectionStatusState.Active
        };
    }

    private static getInactiveStatus(): ConnectionStatus {
        return {
            color: 'orange-warning',
            text: ConnectionStatusState.Inactive
        };
    }
}
